module.exports = __webpack_public_path__ + "static/media/icon-instagram.fc4f87ac.svg";